import React, { useState } from "react";

import { DataTableDef, SelectionMode } from "@plex/react-components";

import { commonMessages } from "infrastructure/localization";
import { useLocalizedValues } from "ui/hooks";
import { glossaryMessages } from "ui/screens/plex-dictionary/plex-dictionary.localization";

import { ITermDictionaryEntry } from "../TermDictionary.state";

import { TermDictionaryGridItem } from "./TermDictionaryGridItem";

export interface ITermDictionaryBilingualGridProps {
  entries?: ITermDictionaryEntry[];
  colNames?: string[];
  keyword?: string;
  onSelectionChanged?: (items: ITermDictionaryEntry[]) => void;
}

export const TermDictionaryBilingualGrid: React.FC<ITermDictionaryBilingualGridProps> = ({ entries, colNames, keyword, onSelectionChanged }) => {
  const localizedValues = useLocalizedValues(() => ({
    placeholderColName: glossaryMessages.property("locale"),
    refineSearch: commonMessages.info("refineSearch"),
    startSearch: commonMessages.info("startSearch")
  }));
  const [selected, setSelected] = useState<ITermDictionaryEntry[]>([]);

  return (
    <DataTableDef<ITermDictionaryEntry>
      data={entries ? entries : []}
      keySelector={row => row.term.termId}
      selectionMode={SelectionMode.single}
      emptyText={entries ? localizedValues.refineSearch : localizedValues.startSearch}
      onSelectionChanged={items => {
        setSelected(items);
        onSelectionChanged && onSelectionChanged(items);
      }}
      selected={selected}
    >
      <DataTableDef.Column<ITermDictionaryEntry>
        id="column1"
        title={(colNames && colNames[0]) || localizedValues.placeholderColName}
        sortable
        valueSelector={e => e.term.translation}
      >
        {row => <TermDictionaryGridItem term={row.term.translation} definition={row.term.definition} keyword={keyword} />}
      </DataTableDef.Column>
      <DataTableDef.Column<ITermDictionaryEntry>
        id="column2"
        title={(colNames && colNames[1]) || localizedValues.placeholderColName}
        sortable
        valueSelector={e => e.translation.translation}
      >
        {row => <TermDictionaryGridItem term={row.translation.translation} definition={row.translation.definition} keyword={keyword} />}
      </DataTableDef.Column>
    </DataTableDef>
  );
};
